// You can write more code here

/* START OF COMPILED CODE */

import ForestTree1 from '@/game/prefabs/World/ForestTree1';
import Mentor3 from '@/game/prefabs/World/Mentors/Mentor3';
import Player from '@/game/prefabs/World/Player';
import Portal from '@/game/prefabs/World/Portal';
import WorldNode from '@/game/prefabs/World/WorldNode';
import TilemapScene from './TilemapScene';
/* START-USER-IMPORTS */
/* END-USER-IMPORTS */

export default class Level14 extends TilemapScene {
  constructor() {
    super('Level14');

    /* START-USER-CTR-CODE */
    /* END-USER-CTR-CODE */
  }

  editorCreate(): void {
    // desert_biome_4
    const desert_biome_4 = this.add.tilemap('desert-biome-4');
    desert_biome_4.addTilesetImage('desert sands v01', 'desert sands v01');
    desert_biome_4.addTilesetImage(
      'obelisks (shadows) v1',
      'obelisks (shadows) v2',
    );
    desert_biome_4.addTilesetImage('desert 16x32', 'desert 16x');
    desert_biome_4.addTilesetImage(
      'desert trees 80x112',
      'desert trees 80x112',
    );
    desert_biome_4.addTilesetImage(
      'desert cactuses 32x96',
      'desert cactuses 32x',
    );
    desert_biome_4.addTilesetImage(
      'desert sands prefabs',
      'desert sands prefabs',
    );
    desert_biome_4.addTilesetImage('collision', 'collision & alpha');

    // terrain_1
    desert_biome_4.createLayer(
      'terrain',
      ['desert sands v01', 'desert sands prefabs'],
      0,
      0,
    );

    // deco_1
    desert_biome_4.createLayer('deco', ['desert sands v01'], 0, 0);

    // cliffs_1
    desert_biome_4.createLayer('cliffs', ['desert sands v01'], 0, 0);

    // obelisk_1
    desert_biome_4.createLayer('obelisk', ['obelisks (shadows) v1'], 0, 0);

    // cOLLISION_1
    const cOLLISION_1 = desert_biome_4.createLayer(
      'COLLISION',
      ['collision'],
      0,
      0,
    )!;
    cOLLISION_1.visible = false;

    // player
    const player = new Player(this, 40, 208);
    this.add.existing(player);

    // portal
    const portal = new Portal(this, 232, 456);
    this.add.existing(portal);

    // worldNode
    const worldNode = new WorldNode(this, 120, 184);
    this.add.existing(worldNode);

    // worldNode_1
    const worldNode_1 = new WorldNode(this, 336, 96);
    this.add.existing(worldNode_1);

    // worldNode_2
    const worldNode_2 = new WorldNode(this, 672, 136);
    this.add.existing(worldNode_2);

    // worldNode_3
    const worldNode_3 = new WorldNode(this, 680, 432);
    this.add.existing(worldNode_3);

    // worldNode_4
    const worldNode_4 = new WorldNode(this, 584, 288);
    this.add.existing(worldNode_4);

    // worldNode_5
    const worldNode_5 = new WorldNode(this, 376, 432);
    this.add.existing(worldNode_5);

    // forestTree1
    const forestTree1 = new ForestTree1(this, 328, 256, 'desert 16x', 1);
    this.add.existing(forestTree1);

    // forestTree
    const forestTree = new ForestTree1(this, 328, 208, 'desert 16x', 1);
    this.add.existing(forestTree);

    // forestTree_1
    const forestTree_1 = new ForestTree1(this, 360, 176, 'desert 16x', 1);
    this.add.existing(forestTree_1);

    // forestTree_2
    const forestTree_2 = new ForestTree1(this, 440, 176, 'desert 16x', 1);
    this.add.existing(forestTree_2);

    // forestTree_3
    const forestTree_3 = new ForestTree1(this, 472, 208, 'desert 16x', 1);
    this.add.existing(forestTree_3);

    // forestTree_4
    const forestTree_4 = new ForestTree1(this, 472, 256, 'desert 16x', 1);
    this.add.existing(forestTree_4);

    // forestTree_5
    const forestTree_5 = new ForestTree1(this, 440, 288, 'desert 16x', 1);
    this.add.existing(forestTree_5);

    // forestTree_6
    const forestTree_6 = new ForestTree1(this, 360, 288, 'desert 16x', 1);
    this.add.existing(forestTree_6);

    // forestTree_7
    const forestTree_7 = new ForestTree1(this, 152, 160, 'desert 16x', 1);
    this.add.existing(forestTree_7);

    // forestTree_8
    const forestTree_8 = new ForestTree1(this, 72, 304, 'desert 16x', 1);
    this.add.existing(forestTree_8);

    // forestTree_9
    const forestTree_9 = new ForestTree1(this, 88, 432, 'desert 16x', 1);
    this.add.existing(forestTree_9);

    // forestTree_10
    const forestTree_10 = new ForestTree1(this, 56, 480, 'desert 16x', 1);
    this.add.existing(forestTree_10);

    // forestTree_11
    const forestTree_11 = new ForestTree1(this, 168, 464, 'desert 16x', 1);
    this.add.existing(forestTree_11);

    // forestTree_12
    const forestTree_12 = new ForestTree1(this, 744, 304, 'desert 16x', 1);
    this.add.existing(forestTree_12);

    // forestTree_13
    const forestTree_13 = new ForestTree1(this, 536, 240, 'desert 16x_1', 1);
    this.add.existing(forestTree_13);

    // forestTree_14
    const forestTree_14 = new ForestTree1(this, 504, 176, 'desert 16x_1', 1);
    this.add.existing(forestTree_14);

    // forestTree_15
    const forestTree_15 = new ForestTree1(this, 408, 144, 'desert 16x_1', 1);
    this.add.existing(forestTree_15);

    // forestTree_16
    const forestTree_16 = new ForestTree1(this, 296, 176, 'desert 16x_1', 1);
    this.add.existing(forestTree_16);

    // forestTree_17
    const forestTree_17 = new ForestTree1(this, 280, 240, 'desert 16x_1', 1);
    this.add.existing(forestTree_17);

    // forestTree_18
    const forestTree_18 = new ForestTree1(this, 296, 320, 'desert 16x_1', 1);
    this.add.existing(forestTree_18);

    // forestTree_19
    const forestTree_19 = new ForestTree1(this, 392, 352, 'desert 16x_1', 1);
    this.add.existing(forestTree_19);

    // forestTree_20
    const forestTree_20 = new ForestTree1(this, 504, 320, 'desert 16x_1', 1);
    this.add.existing(forestTree_20);

    // mentor
    const mentor = new Mentor3(this, 48, 144);
    this.add.existing(mentor);

    // worldNode_6
    const worldNode_6 = new WorldNode(this, 168, 488);
    this.add.existing(worldNode_6);

    // worldNode_7
    const worldNode_7 = new WorldNode(this, 256, 152);
    this.add.existing(worldNode_7);

    // worldNode_8
    const worldNode_8 = new WorldNode(this, 720, 272);
    this.add.existing(worldNode_8);

    // worldNode_9
    const worldNode_9 = new WorldNode(this, 488, 400);
    this.add.existing(worldNode_9);

    // worldNode (prefab fields)
    worldNode.NPCLevelId = 13;
    worldNode.NPCId = 0;

    // worldNode_1 (prefab fields)
    worldNode_1.NPCLevelId = 13;
    worldNode_1.NPCId = 1;

    // worldNode_2 (prefab fields)
    worldNode_2.NPCLevelId = 13;
    worldNode_2.NPCId = 2;

    // worldNode_3 (prefab fields)
    worldNode_3.NPCLevelId = 13;
    worldNode_3.NPCId = 3;

    // worldNode_4 (prefab fields)
    worldNode_4.NPCLevelId = 13;
    worldNode_4.NPCId = 4;

    // worldNode_5 (prefab fields)
    worldNode_5.NPCLevelId = 13;
    worldNode_5.NPCId = 5;

    // worldNode_6 (prefab fields)
    worldNode_6.NPCLevelId = 13;
    worldNode_6.NPCId = 5;

    // worldNode_7 (prefab fields)
    worldNode_7.NPCLevelId = 13;
    worldNode_7.NPCId = 5;

    // worldNode_8 (prefab fields)
    worldNode_8.NPCLevelId = 13;
    worldNode_8.NPCId = 5;

    // worldNode_9 (prefab fields)
    worldNode_9.NPCLevelId = 13;
    worldNode_9.NPCId = 5;

    this.player = player;
    this.portal = portal;
    this.mentor = mentor;
    this.desert_biome_4 = desert_biome_4;

    this.events.emit('scene-awake');
  }

  private player!: Player;
  private portal!: Portal;
  private mentor!: Mentor3;
  private desert_biome_4!: Phaser.Tilemaps.Tilemap;

  /* START-USER-CODE */

  // Write your code here

  create() {
    this.editorCreate();
    this.initialize({
      camera: this.cameras.main,
      player: this.player,
      tilemap: this.desert_biome_4,
      portal: this.portal,
      mentor: this.mentor,
    });
  }

  /* END-USER-CODE */
}

/* END OF COMPILED CODE */

// You can write more code here
